/**
 * Base do webhook-server: produção atrás do nginx usa o caminho /webhook;
 * desenvolvimento local fala direto com a porta 3002.
 */
export function webhookBase(): string {
  if (window.location.hostname.includes('essencemedicalclinic')) {
    return '/webhook';
  }
  // desenvolvimento: o .env pode apontar para outra instância local (ex.: a
  // só-API da worktree na 3012, com SEM_ROTINAS=1)
  return process.env.REACT_APP_WEBHOOK_URL || 'http://localhost:3002';
}
